<div fxFlex="80" fxFlexOffset="10">
  <div class="toto">
    <h2 class="title-CVM">Upload and Download Csv Files</h2>
    @if (importFileCsvs.length !== 0) { @for (function of importFileCsvs; track function.id) {
    <div>
      <mic-app-import-file [func]="function"></mic-app-import-file>
    </div>
    } } @else {
    <mic-empty-state icon="layers_clear" title="There is no Function to display."> </mic-empty-state>
    }
  </div>
</div>
